import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  width: 100%;
`;

export const Card = styled.div<{ isSelected: boolean }>`
  display: flex;
  flex-direction: column;
  border: 2px solid ${props => (props.isSelected ? '#E97425' : '#ddd')};
  border-radius: 8px;
  padding: 16px;
  min-width: 280px;
  max-width: 320px;
  flex: 1;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  background-color: ${props => (props.isSelected ? '#fff9f5' : '#fff')};

  &:hover {
    border-color: #E97425;
    box-shadow: 0 2px 8px rgba(233, 116, 37, 0.15);
  }
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 12px;
`;

export const IconContainer = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
`;

export const RadioButton = styled.div<{ isSelected: boolean }>`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid ${props => (props.isSelected ? '#E97425' : '#ccc')};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  &::after {
    content: '';
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: ${props => (props.isSelected ? '#E97425' : 'transparent')};
  }
`;

export const Title = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0 0 8px 0;
`;

export const PriceBadge = styled.div<{ isFree: boolean }>`
  display: inline-block;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 12px;
  background-color: ${props => (props.isFree ? '#e6f7e6' : '#fff5eb')};
  color: ${props => (props.isFree ? '#28a745' : '#E97425')};
`;

export const Description = styled.p`
  font-size: 14px;
  color: #666;
  margin: 0 0 12px 0;
  line-height: 1.4;
`;

export const ServiceInfo = styled.p`
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin: 0 0 8px 0;
`;

export const ServicesTitle = styled.p`
  font-size: 13px;
  font-weight: 600;
  color: #666;
  margin: 0 0 8px 0;
`;

export const ServicesList = styled.ul`
  margin: 0;
  padding-left: 20px;
  list-style-type: disc;
`;

export const ServiceItem = styled.li<{ isHighlight?: boolean }>`
  font-size: 13px;
  color: ${props => (props.isHighlight ? '#E97425' : '#666')};
  font-weight: ${props => (props.isHighlight ? '600' : '400')};
  margin-bottom: 4px;
  line-height: 1.4;
`;

export const TotalSection = styled.div`
  margin-top: 16px;
  padding: 12px;
  background-color: #f9f9f9;
  border-radius: 6px;
`;

export const TotalLabel = styled.span`
  font-size: 14px;
  color: #666;
`;

export const TotalValue = styled.span`
  font-size: 18px;
  font-weight: 700;
  color: #333;
  margin-left: 8px;
`;


